/* Native media contracts; no Canopy presentation. */
(() => {
  'use strict';
  function stopMedia(container){
    container.querySelectorAll('video').forEach(video=>video.pause());
    container.querySelectorAll('iframe').forEach(frame=>{const src=frame.getAttribute('src');if(src)frame.setAttribute('src',src);});
    container.querySelectorAll('model-viewer').forEach(model=>model.liotroModelUI?.pause());
  }
  function createModelSupport({shopify,getXR,listen,models,viewers,failed}){
    let started=false,registered=false,disposed=false;
    function setupXR(errors){
      if(disposed)return;
      if(errors){failed();return;}
      const xr=getXR();if(!xr){listen('shopify_xr_initialized',()=>setupXR(),{once:true});return;}
      if(!registered){xr.addModels(models);registered=true;}xr.setupXRElements();
    }
    const initialize=()=>{
      if(disposed||started||!models.length)return;started=true;
      if(!shopify?.loadFeatures){failed();return;}
      shopify.loadFeatures([
        {name:'model-viewer-ui',version:'1.0',onLoad(errors){if(disposed)return;if(errors){failed();return;}viewers().forEach(model=>{if(!model.liotroModelUI)model.liotroModelUI=new shopify.ModelViewerUI(model);});}},
        {name:'shopify-xr',version:'1.0',onLoad:setupXR}
      ]);
    };
    initialize.dispose=()=>{disposed=true;};return initialize;
  }
  const instances=window.LiotroLifecycle.create({selector:'#liotro-media-dialog',setup(dialog){
  const controller=new AbortController(),options={signal:controller.signal};
  const host=dialog.querySelector('[data-liotro-media-host]');let active=0,entries=[];
  const models=JSON.parse(dialog.closest('.shopify-section')?.querySelector('[data-liotro-models]')?.content.textContent||'[]');
  const initializeModels=createModelSupport({shopify:window.Shopify,getXR:()=>window.ShopifyXR,listen:(name,fn,opts)=>document.addEventListener(name,fn,{...opts,...options}),models,viewers:()=>host.querySelectorAll('model-viewer'),failed(){const message=dialog.querySelector('[data-media-error]');message.textContent=window.LiotroText('liotro.content.la_visualizzazione_3d_non_e_disponibil_16ad59');message.hidden=false;}});
  function show(index){
    if(!entries.length)return;
    entries.forEach(entry=>{stopMedia(entry);entry.hidden=true;});
    active=(index+entries.length)%entries.length;entries[active].hidden=false;
    dialog.querySelector('[data-media-position]').textContent=`${active+1} / ${entries.length}`;
    dialog.querySelectorAll('[data-media-previous],[data-media-next]').forEach(button=>button.disabled=entries.length<2);
  }
  function openMedia(trigger){
    if(!entries.length){host.append(dialog.querySelector('[data-liotro-media-content]').content.cloneNode(true));entries=[...host.querySelectorAll('[data-media-id]')];}
    const source=trigger.dataset.mediaPreview;
    const selected=entries.findIndex(entry=>source?entry.dataset.mediaId===source:new URL(entry.dataset.mediaSrc,location.href).href===trigger.src);
    show(selected<0?0:selected);dialog.showModal();document.body.classList.add('dialog-open');initializeModels();
  }
  dialog.querySelector('[data-media-previous]').addEventListener('click',()=>show(active-1),options);
  dialog.querySelector('[data-media-next]').addEventListener('click',()=>show(active+1),options);
  dialog.addEventListener('close',()=>stopMedia(host),options);
  return {open:openMedia,dispose(){controller.abort();initializeModels.dispose();stopMedia(host);if(dialog.open)dialog.close();document.body.classList.toggle('dialog-open',Boolean(document.querySelector('dialog[open]')));}};
  }});
  function openCurrent(trigger){instances.mount(document);const dialog=document.querySelector('#liotro-media-dialog');instances.get(dialog)?.open(trigger);}
  document.addEventListener('click',event=>{const trigger=event.target.closest('[data-product-media-open],[data-media-preview]');if(trigger)openCurrent(trigger);});
  document.addEventListener('keydown',event=>{if(event.target.matches('[data-product-media-open]')&&['Enter',' '].includes(event.key)){event.preventDefault();openCurrent(event.target);}});
  window.LiotroMedia={stopMedia,createModelSupport,mount:instances.mount,unmount:instances.unmount};instances.mount(document);
})();
